import Header from "./Header";
import Preview from "./Preview";

const Hero = () => {
    return ( 
        <div className="bg-hero bg-cover lg:h-screen">
        <Header home={true} />
        <Preview />
        </div>
     );
}
 
export default Hero;